import $ from 'jquery';
import { prepareChessboard, validateDrag, validateDrop, restrictMove, validateMove, showMagnus, loadNextConfiguration } from '../../utils';
import User from '../../classes/user';
import ChessBoard from '../../components/chessBoard';
import { ACTIVITY_SUCCESS_AUDIO, WRONG_ANSWER_AUDIO } from '../../utils/constants';


/**
 * @name lesson15Activity1
 * @function
 * @param { config }
 * @description: Drag queens 4x4.
 */

export function lesson15Activity1(config) {
    let position = config.position,
        next = config.next,
        fen = config.fen,
        pieceLimit = config.pieceLimit,
        piecesArray = config.piecesArray ? config.piecesArray : [],
        validatePieces = config.validatePieces ? config.validatePieces : [];

    let afterLoad = function () {
        prepareChessboard(config);
        $('#chessBoard').addClass('custom-background-image-4x4');
        $('.row-5277c:nth-child(-n+4), .row-5277c .square-55d63:nth-last-child(-n+5)').css('display', 'none');
        $('.square-a3, .square-b1').css('pointer-events', 'none');
    }

    let onDragStart = function (source, piece, position, orientation) {
        validateDrag(piece, pieceLimit[piece])
    };

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        let bubbleConfig = {
            data: `Good Job ${User.user.name}!`,
            position: 'left',
            styleClass: 'xs'
        };

        validatePosition(piecesArray.length, fen, next, bubbleConfig, false, true)
        return validateDrop(piece, pieceLimit[piece], target, validatePieces, true)
    }

    function validatePosition(pieceLimit, resultFen, next, bubbleConfig = null, isQA = false, celebrationSound) {
        if ($(".piece-417db").length >= (12 + pieceLimit)) {
            setTimeout(function () {
                let fen = ChessBoard.board.fen()

                if (resultFen.includes(fen)) {
                    if (celebrationSound) {
                        $(document).trigger('audio-play', ACTIVITY_SUCCESS_AUDIO);
                    }
                    if (bubbleConfig) {
                        showMagnus(bubbleConfig)
                        loadNextConfiguration(4000, next, celebrationSound)
                    } else {
                        loadNextConfiguration(2000, next, celebrationSound)
                    }
                }
            }, 100)
        }
    }

    const chessConfig = {
        config: {
            position: position,
            draggable: true,
            dropOffBoard: 'trash',
            sparePieces: true,
            onDrop: onDrop,
            onDragStart: onDragStart,
            pieceTheme: `img/chesspieces/${config.pieceTheme}/{piece}.svg`
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson15Activity2
 * @function
 * @param { config }
 * @description: Drag queens 8x8.
 */

export function lesson15Activity2(config) {
    let position = config.position,
        pieceLimit = config.pieceLimit,
        next = config.next,
        count = 0,
        board = '',
        limit = 2,
        queens = 0,
        letters = /^[A-Za-z]+$/;

    let afterLoad = function () {
        prepareChessboard(config);
        $('.square-55d63').css('pointer-events', 'auto');
        $('.next-btn-container #next, .back-btn-container #previous').click(function () {
            count = 0;
            board = '';
            limit = 2;
        });
    }

    let onDragStart = function (source, piece, position, orientation) {
        validateDrag(piece, pieceLimit[piece])
    };

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        return validateQueenDrop(piece)
    }

    function validateQueenDrop(piece) {
        setTimeout(function () {
            let pieceCount = $(".board-b72b1 img[data-piece = " + piece + "]").length;

            if (pieceCount <= 0) {
                $(document).trigger("audio-play", WRONG_ANSWER_AUDIO)
                $(".sparepieces_container img[data-piece = " + piece + "]").css("visibility", "visible");
                return 'trash';
            }
        }, 100)
    }

    var onSnapEnd = function (source, target, piece) {
        count++;
        queens = $(".board-b72b1 img").length;
        let boardFen = ChessBoard.board.fen();
        let str = boardFen.split("/");
        for (let i = 0; i < str.length; i++) {
            for (let k = 0; k < str[i].length; k++) {
                if (!str[i][k].match(letters)) {
                    let num = parseInt(str[i][k], 10);
                    for (let j = 0; j < num; j++) {
                        board = board + '0'
                    }
                } else {
                    board = board + '1'
                }
            }
            board = board + '/'
        }
        let boardArr = board.split('/');
        boardArr.pop();
        let check = validateBoard(boardArr);
        if (check === true) {
            board = '';
        }
        if (check === true && count >= 8 && queens === 8) {
            showMagnus({
                data: 'Wow, that was awesome!',
                position: 'left',
                styleClass: 'md'
            })
            loadNextConfiguration(5000, next, true);
        } else if (check === false) {
            $('.square-55d63').css('pointer-events', 'none');
            count = 0;
            board = '';
            limit--;
            if (limit <= 0) {
                showMagnus({
                    data: 'That\'s ok. It is a challenge.',
                    position: 'left',
                    styleClass: 'md'
                })
                loadNextConfiguration(4000, next, false);
            } else {
                showMagnus({
                    data: 'Oops! Queens can attack each other. Try again',
                    position: 'left',
                    styleClass: 'lg'
                })
                setTimeout(function () {
                    ChessBoard.board.position(position);
                    ChessBoard.game = new window.Chess(position);
                    loadNextConfiguration(500, next - 1, false);
                }, 4500)
            }
        }
    }

    function validateBoard(board) {
        let firstValue = 0, fourthValue = 0;
        for (let i = 0; i < 8; i++) {
            for (let j = 0; j < 8; j++) {
                if (board[i][j] === '1') {
                    firstValue++;
                }
                if (board[j][i] === '1') {
                    fourthValue++;
                }
            }
            if (firstValue > 1 || fourthValue > 1) {
                return false;
            }
            firstValue = 0;
            fourthValue = 0;
        }
        if (!diagonal(board)) {
            return false
        }
        if (!diagonal(board, true)) {
            return false;
        }
        return true;
    }

    function diagonal(board, bottomToTop) {
        var Ylength = board.length;
        var Xlength = board[0].length;
        var maxLength = Math.max(Xlength, Ylength);
        var temp;
        var returnArray = [];
        var value = 0;

        for (var k = 0; k <= 2 * (maxLength - 1); ++k) {
            temp = [];
            for (var y = Ylength - 1; y >= 0; --y) {
                var x = k - (bottomToTop ? Ylength - y : y);
                if (x >= 0 && x < Xlength) {
                    temp.push(board[y][x]);
                }
            }
            if (temp.length > 1) {
                returnArray.push(temp.join(''))
            }
        }
        for (var i = 0; i < returnArray.length; i++) {
            for (var j = 0; j < returnArray[i].length; j++) {
                if (returnArray[i][j] === '1') {
                    value++;
                }
            }
            if (value > 1) {
                return false
            }
            value = 0;
        }
        return true
    }

    const chessConfig = {
        config: {
            position: position,
            sparePieces: true,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd,
            pieceTheme: `img/chesspieces/${config.pieceTheme}/{piece}.svg`
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson15Activity3
 * @function
 * @param { config }
 * @description: End game
 */

export function lesson15Activity3(config) {
    let position = config.position,
        next = config.next,
        finalPosition = config.resultFen,
        boardFen;

    let afterLoad = function () {
        prepareChessboard(config);
    }

    let onDragStart = function (source, piece, position, orientation) {
        return restrictMove(piece, config.restrictMoveOf);
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        return validateMove(source, target, piece, true);
    }

    var onSnapEnd = function (source, target, piece) {
        boardFen = ChessBoard.board.fen();
        if (boardFen === finalPosition) {
            showMagnus({
                data: 'Nice job!',
                position: 'left',
                styleClass: 'md'
            })
            loadNextConfiguration(2000, next, true);
        } else if (source === 'e5' && target === 'a1') {
            showMagnus({
                data: 'Oops, that wasn\'t safe double attack! Try again',
                position: 'left',
                styleClass: 'lg'
            })
            ChessBoard.board.move(`${config.from}-${config.to}`)
            setTimeout(function () {
                ChessBoard.board.position(position);
                ChessBoard.game = new window.Chess(position + config.initialMoveOf);
            }, 3000)
        } else {
            showMagnus({
                data: `Oops! That's not the right move`,
                position: 'left',
                styleClass: 'md'
            })
            ChessBoard.board.position(position);
            ChessBoard.game = new window.Chess(position + config.initialMoveOf);
        }
    }

    let chessConfig = {
        config: {
            position: position,
            next: next,
            draggable: true,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd,
            moveSpeed: 1000
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}



// WEBPACK FOOTER //
// ./src/lessons/lesson_15/assignments.js